import { render, staticRenderFns } from "./LectureLessonEdit.vue?vue&type=template&id=2617f3b4&"
import script from "./LectureLessonEdit.vue?vue&type=script&lang=js&"
export * from "./LectureLessonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports